import * as React from 'react'
import '../Dropdown/styles/Dropdown.css'
import { DropdownArrowIcon } from '../../../images/icons/DropdownArrow/DropdownArrow'

class FetchSearchSelect extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
        this.state = {
            open: false,
            active: false,
            selected: '',
            items: [],
            searchItem: '',
        }
    }

    componentDidMount() {
        const { occupancyType = 'Commercial occupancy', fetchOccupancies, sortOrder = '' } = this.props
        fetchOccupancies(occupancyType, '', sortOrder)
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.itemList !== this.props.itemList) {
            this.setState({ items: this.props.itemList })
        }

        if (prevProps.selected !== this.props.selected) {
            this.setState({ selected: this.props.selected })
        }
    }

    filterList = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { occupancyType = 'Commercial occupancy', fetchOccupancies, sortOrder = '' } = this.props
        const query = event.target.value
        this.setState({ searchItem: query })
        // if (query) {
        fetchOccupancies(occupancyType, query, sortOrder)
        // }
    }

    toggleList = () => {
        if (!this.props.disableDropdown) {
            this.setState((prevState) => ({ open: !prevState.open }))
        }
    }

    selectItem = (item: [string, string]) => {
        this.setState({ selected: item[1], active: true })
        this.props.setFieldValue(this.props.name, item[0])
        this.toggleList()
    }

    handleClickOutside = (evt) => {
        if (this.state.open) {
            this.toggleList()
        }
    }

    formatState(state: any) {
        if (!state.id) {
            return state.title
        }
        var $state
        this.props.itemList.map((item, i) => (
            $state =
            <span>{state.title}</span>
        ))

        return $state
    }
    SearchItem = (e) => {
        this.setState({ SearchItem: e.target.value })
    }

    render() {
        const { style, label, labelShow = true, searchPlaceholder = 'Search Country', customCls = '',
            disable = false } = this.props
        const { items, selected } = this.state

        let listStyles = {
            height: (this.state.open) ? '200px' : '0px',
        }

        return (
            <div
                className={`dropdown${this.state.open ? ' open' : ''} ${customCls} ${disable ? 'disable_events' : ''}`}
                style={{...style}}
            >
                {labelShow && <div className={`dropdown__label${this.state.active ? ' active' : ''}`}>{label}</div>}
                <div
                    className={`dropdown__selected ${(items.length < 1 || disable) ? 'disabled' : ''}`}
                    onClick={this.toggleList}
                >
                    <span>{selected || label}</span>
                    {!this.props.disableDropdown ? <DropdownArrowIcon color={'#fca61b'} /> : null}
                </div>
                {/* {this.state.open && ( */}
                <div className="dropdown__list" style={listStyles}>
                    <span className="select2-search select2-search--dropdown">
                        <input
                            className="select2-search__field"
                            type="search"
                            role="searchbox"
                            aria-autocomplete="list"
                            placeholder={searchPlaceholder}
                            onChange={this.filterList}
                        />
                    </span>
                    {items.length > 0 ? (
                        items.map((item: any, i: any) => (
                            <div
                                key={i}
                                className="dropdown__item"
                                data-category={item.id}
                                onClick={() => this.selectItem([item.id, item.title])}
                            >
                                {item.title}
                            </div>
                        ))
                    ) : (
                        <div className="dropdown__item">No Data Found</div>
                    )}
                </div>
                {/* )} */}
            </div>
        )
    }
}

export default FetchSearchSelect



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/FetchSearchSelect/FetchSearchSelect.tsx